export default __webpack_public_path__ + "9c2f74fbca86dedcd3496af45e060692.svg";